import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';

const TextDriftSpeedListItem = (props) => {
    const { speed, index, updateTextElement } = props;

    const onSpeedChange = (value) => updateTextElement(index, { drift: { speed: value } });

    return (
        <SliderListItem
            title='Speed'
            displayMultiplier={50}
            value={speed}
            min={0}
            max={100}
            step={1}
            onValueChange={onSpeedChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { speed } = state.createPreview.present.videoSettings.text.textElements[ownProps.index].drift;
    return { speed };
};

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextDriftSpeedListItem);
